module.exports = __webpack_public_path__ + "media/images/sk50-5ccf824de5effa31e5293fcf264b31eb.svg";